module.exports = __webpack_public_path__ + "static/media/adlogImage.eae32762.png";